module.exports = __webpack_public_path__ + "img/ic_list_back.594e0748.svg";